// src/config/routes.js
const routes = {
  LANDING: '/',
  SIGNUP: '/signup',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  USER_VERIFICATION: '/verify-email',
  HOME: '/home',
  CONVERSATION_TRANSCRIPT: '/conversation/:conversationId/transcript',
  CONVERSATION_SUMMARY: '/conversation/:conversationId/summary',
  CONVERSATION_ANNOTATE: '/conversation/:conversationId/annotate',
  CHAT: '/chat',
  RECORD: '/record',
  RECORD_CONVERSATION: '/record/:conversation_id',
  LIVETRANSCRIPT: '/watch/:sessionId',
  NOTE: '/note/:sessionId',
  DELETE_NOTE: '/delete-note/:sessionId',
  LOGOUT: '/logout',
  PROFILE: '/profile',
  UPGRADE: '/upgrade',
  SUMMARY:'/summary',
  PAYMENT: '/payment',
  PAYMENT_SUCCESS: '/payment-success',
  PAYPAL_SUCCESS: '/paypal-success',
  PAYPAL_FAILURE: '/paypal-failure',
  PLANS: '/plans',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service'
};

export default routes;
